/* globals console, module, require, window */
/* jshint esversion:6, globalstrict:true */
'use strict';

const handlebars = require('handlebars'),
    jQuery = require('jquery'),
    //
    codeValues = require('./enumerations').codeValues,
    enumerations = require('./enumerations').enumerations,
    templates = require('handlebars').templates,
    tips = require('./tips').tips,
    configuration = require('./configuration'),
    user = require('../models/user'),
    tipaudit = require('./configuration').tipaudit,
    _ = require('lodash'),
    detipify = function (code, preserveHtml, stripAll) {
        const leftCeiling = decodeURIComponent('%E2%8C%88'),
            rightFloor = decodeURIComponent('%E2%8C%8B');
        let s = tips[code] || ('❦' + code);
        if (!preserveHtml) {
            if (stripAll) {
                s = s.replace(/<\/?[^>]+(>|$)/g, "");
            } else {
                s = s.replace(/<\/?(p)\b[^<>]*>/g, ''); // remove possible <p></p> tags
            }
            s = tipaudit ? leftCeiling + s + rightFloor : s;
        } else {
            s = tipaudit ? leftCeiling + leftCeiling + s + rightFloor + rightFloor : s;
        }
        return s;
    },
    helpers = {
        enum: function (hash) {
            return (enumerations[hash.property] && enumerations[hash.property][hash.id]) ? enumerations[hash.property][hash.id] : hash.property + '_' + hash.id;
        },
        enumRadios: function (hash) {
            const contexts = [],
                radios = [],
                titleClass = hash.titleClass || 'edit-item-title';
            if (hash.label) {
                radios.push('<label class="' + titleClass + '">' + detipify(hash.label) + ':</label>');
            }
            hash.values = _.isArray(hash.values) ? hash.values : [];
            _.each(enumerations[hash.property], function (tip, id) {
                if (!hash.skipOther || !tip.code.endsWith('Other')) {
                    id = +id;
                    contexts.push({
                        checked: _.includes(hash.values, id),
                        disabled: hash.disabled === true ? true : false,
                        groupId: hash.groupId,
                        id: id,
                        label: detipify(tip.code),
                        name: hash.property,
                        order: tip.order
                    });
                }
            });
            contexts.sort(function (a, b) {
                return a.order - b.order;
            });
            _.each(contexts, function (context, index) {
                if (index === 0 && hash.values.length === 0) {
                    context.checked = true;
                }
                radios.push(templates.radio(context));
            });
            if (hash.includeNoSelectionSentry) {
                radios.push(templates.radio({
                    groupId: hash.groupId,
                    name: hash.property,
                    noSelectionSentry: true
                }));
            }
            return radios.join('\n');
        },
        enumCheckboxes: function (hash) {
            const contexts = [],
                checkboxes = [],
                titleClass = hash.titleClass || 'edit-item-title';
            if (hash.label) {
                checkboxes.push('<label class="' + titleClass + '">' + detipify(hash.label) + ':</label>');
            }
            hash.values = _.isArray(hash.values) ? hash.values : [];
            _.each(enumerations[hash.property], function (tip, id) {
                if (!hash.skipOther || !tip.code.endsWith('Other')) {
                    id = +id;
                    contexts.push({
                        checked: _.includes(hash.values, id),
                        groupId: hash.groupId,
                        id: id,
                        label: detipify(tip.code),
                        name: hash.property,
                        order: tip.order,
                        required: hash.requireOne === true
                    });
                }
            });
            contexts.sort(function (a, b) {
                return a.order - b.order;
            });
            _.each(contexts, function (context) {
                checkboxes.push(templates.checkbox(context));
            });
            if (hash.includeNoSelectionSentry) {
                checkboxes.push(templates.checkbox({
                    groupId: hash.groupId,
                    name: hash.property,
                    noSelectionSentry: true
                }));
            }
            return checkboxes.join('\n');
        },
        enumL10n: function (hash) {
            let s = '';
            if (hash.id) {
                s = detipify((enumerations[hash.property] && enumerations[hash.property][hash.id]) ? enumerations[hash.property][hash.id].code : hash.property + '_' + hash.id);
            }
            if (hash.ids) {
                console.warn('handlebars.enumL10n - unexpected hash.ids (%s)', hash.property);
            }
            return s;
        },
        enumSelect: function (hash) {
            const options = [],
                titleClass = hash.titleClass || 'edit-item-title',
                label = hash.label ? '<label for="' + hash.label + '" class="' + titleClass + '">' + detipify(hash.label) + ':</label>\n' : '',
                id = hash.label ? hash.label : '';
            // initial option representing a null value. Note that we cannot use these controls to UNSET a set value, just to represent an unset value.
            if (!hash.selected) {
                options.push({
                    option: '',
                    order: -1,
                    selected: true,
                    value: '-1' // sentinal value of -1 will be dropped by the form processor...
                });
            }
            if (hash.selected === -1) {
                // -1 indicates that the first options should be selected...
                hash.selected = _.keys(enumerations[hash.property])[0];
            }
            _.each(enumerations[hash.property], function (tip, id) {
                id = +id;
                options.push({
                    option: detipify(tip.code),
                    order: tip.order,
                    selected: id === hash.selected,
                    value: id
                });
            });
            options.sort(function (a, b) {
                return a.order - b.order;
            });
            return label + templates.select({
                disabled: hash.disabled,
                id: id,
                name: hash.property,
                options: options,
                selectedValue: hash.selected
            });
        },
        enumUl: function (hash) {
            const contexts = [],
                ul = ['<ul>'];
            _.each(hash.ids, function (id) {
                let tip = enumerations[hash.property][id];
                if (!tip) { // @acavan! - is this the best place to handle unknown ids?
                    tip = {
                        code: hash.property + '_' + id,
                        order: 999
                    };
                }
                contexts.push({
                    li: detipify(tip.code),
                    order: tip.order
                });
            });
            contexts.sort(function (a, b) {
                return a.order - b.order;
            });
            _.each(contexts, function (context) {
                ul.push('   <li>' + context.li + '</li>');
            });
            ul.push('</ul>');
            return ul.join('');
        },
        enumUlDEPRECATED: function (property, ids) {
            const contexts = [],
                ul = ['<ul>'];
            _.each(ids, function (id) {
                const tip = enumerations[property][id];
                contexts.push({
                    li: detipify(tip.code),
                    order: tip.order
                });
            });
            contexts.sort(function (a, b) {
                return a.order - b.order;
            });
            _.each(contexts, function (context) {
                ul.push('   <li>' + context.li + '</li>');
            });
            ul.push('</ul>');
            return ul.join('\n');
        },
        l10n: function (x, hash) {
            let s;
            if (typeof this === 'string') {
                s = this;
            } else if (typeof x === 'string') {
                s = x;
                // } else if (typeof x === 'object' && x.fn) {
                //     s = x.fn();
            } else if (typeof x === 'function') {
                s = x();
            } else {
                s = '<?>';
            }
            s = detipify(s, hash ? hash.preserveHtml : false, hash ? hash.stripAll : false);
            // optional terminator
            if (hash && hash.term && !s.endsWith(hash.term)) {
                s = s + hash.term;
            }
            return s;
        },
        localeDate: function (d) {
            return new Date(d).toLocaleDateString();
        },
        popoutUrl: function () {
            return configuration.embedded ? 'https://' + user.get('host') + '/places.htm' : window.location.origin + window.location.pathname;
        },
        telephone: function (s) {
            // assumes we have 11 digits with optional 'x' + n digits (e.g.14155551212x1234)
            // returns as 1-415-555-1212x1234
            let a;
            if (s) {
                a = s.split('x');
                return [a[0].substr(0, 1), a[0].substr(1, 3), a[0].substr(4, 3), a[0].substr(7, 4)].join('-') + (a[1] ? ' x' + a[1] : '');
            } else {
                return s;
            }
        },
        countyName: function (countyId) {
            if (countyId && enumerations.countyId[countyId]) {
                return this.l10n(enumerations.countyId[countyId].code, {});
            }
            return '';
        },
        arrayIncludes: function (args) {
            const values = _.slice(args, 0, args.length - 2),
                array = args[args.length - 2];
            return _.intersection(array, values).length ? true : false;
        }
    };

module.exports = {
    initialize: function (callback) {
        handlebars.registerHelper('addressLine', function () {
            return templates.addressLine(this);
        });
        handlebars.registerHelper('analytics', function (options) {
            return 'data-analytics=\'' + JSON.stringify(options.hash) + '\'';
        });
        handlebars.registerHelper('camelCase', function (s) {
            return _.camelCase(s);
        });
        handlebars.registerHelper('codeValue', function (code) {
            if (!codeValues[code]) {
                console.log('handlebars.codeValue - unknown code:%s', code);
            }
            return codeValues[code] || -1;
        });
        handlebars.registerHelper('concat', function () {
            return _.slice(arguments, 0, arguments.length - 1).join(' ');
        });
        handlebars.registerHelper('enum', function (options) {
            return helpers.enum(options.hash);
        });
        handlebars.registerHelper('enum_checkboxes', function (options) {
            return helpers.enumCheckboxes(options.hash);
        });
        handlebars.registerHelper('enum_l10n', function (options) {
            return helpers.enumL10n(options.hash);
        });
        handlebars.registerHelper('enum_radios', function (options) {
            return helpers.enumRadios(options.hash);
        });
        handlebars.registerHelper('enum_select', function (options) {
            return helpers.enumSelect(options.hash);
        });
        handlebars.registerHelper('enum_ul', function (options) {
            return helpers.enumUl(options.hash);
        });
        handlebars.registerHelper('ifArrayIncludes', function () {
            const options = arguments[arguments.length - 1];
            return helpers.arrayIncludes(arguments) ? options.fn(this) : options.inverse(this);
        });
        handlebars.registerHelper('unlessArrayIncludes', function () {
            const options = arguments[arguments.length - 1];
            return !helpers.arrayIncludes(arguments) ? options.fn(this) : options.inverse(this);
        });
        handlebars.registerHelper('ifListIncludes', function () {
            const a = _.values(arguments),
                value = a[0] || '',
                list = a.slice(1, a.length - 1),
                options = a.slice(a.length - 1)[0];
            return list.includes(value.split('/')[0]) ? options.fn(this) : options.inverse(this); // re: .split('/')[0] - e.g. 'assessments/first' -> 'assessments'
        });
        handlebars.registerHelper('l10n', function (x, options) {
            return helpers.l10n(x, options.hash);
        });
        handlebars.registerHelper('l10n_nb', function (x, options) {
            return helpers.l10n(x, options.hash).replace(/ /g, '&nbsp;');
        });
        handlebars.registerHelper('l10n_lc', function (x, options) {
            const s = helpers.l10n(x, options.hash);
            return s.indexOf('❦') === -1 ? s.toLowerCase() : s; // don't lower case missing tips codes
        });
        handlebars.registerHelper('l10n_raw', function (x, options) {
            return helpers.l10n(x, _.extend({preserveHtml: true}, options.hash));
        });
        handlebars.registerHelper('localeDate', function (d) {
            return helpers.localeDate(d);
        });
        handlebars.registerHelper('pageNoLongerAvailable', function () {
            return templates.pageNoLongerAvailable();
        });
        handlebars.registerHelper('radiosYesNo', function (options) {
            options.hash[options.hash.default === 'no' ? 'defaultNo' : 'defaultYes'] = true;
            return templates.radioYesNo(options.hash);
        });
        handlebars.registerHelper('telephone', function (s) {
            return helpers.telephone(s);
        });
        // tel: URI scheme. Assumes phone number has been conditioned to be free of punctuation, and leads any extension with 'x'.
        handlebars.registerHelper('telScheme', function (s) {
            return s ? 'tel:+' + s.replace('x', ',') : '';   // comma plus extension
        });
        handlebars.registerHelper('toLowerCase', function (s) {
            return s.toLowerCase();
        });
        handlebars.registerHelper('toTitleCase', function (s) {
            return _.startCase(s);
        });
        handlebars.registerHelper('toSentenceCase', function (s) {
            const a = s.split(' ');
            a[0] = _.startCase(a[0]);
            return a.join(' ');
        });
        handlebars.registerHelper('toUpperCase', function (s) {
            return s.toUpperCase();
        });
        handlebars.registerHelper('truncate', function (n) {
            return Math.floor(n);
        });
        handlebars.registerHelper('urlEncode', function (s) {
            return encodeURIComponent(s);
        });
        handlebars.registerHelper('pattern', function (pattern) {
            const patterns = {
                    phone: /^(\+?1-?)?(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9]))-?[2-9]\d{2}-?\d{4}( x[0-9]*)?$/,
                    // e.g. +1(415)555-1212 x1234 and variants such as 415-555-1212, 4155551212, 14155551212 x567 etc.
                    // website: /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
                    // website: /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
                    website: /^(http:\/\/|https:\/\/)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
                    // e.g. require http:// or https:// not sure why we have the additional
                    zip: /^\d{5}(?:[-\s]\d{4})?$/
                    // e.g. 12345, 12345-1234
                };
            if (!patterns[pattern]) {
                console.error('handlebars.helpers.pattern - unknown pattern:%s', pattern);
                return '';
            }
            return patterns[pattern].toString().slice(1, -1).replace(/"/g, '\\\"'); // exclude regex fore and back slashes
        });
        handlebars.registerHelper('configuration', function (key) {
            return configuration[key] || 'unknown_key_' + key;
        });
        handlebars.registerHelper('year', function () {
            return (new Date()).getFullYear();
        });
        handlebars.registerHelper('dateString', function (date) {
            return (new Date(date || new Date())).toISOString().slice(0, 10);  // 2019-02-01
        });
        handlebars.registerHelper('debug', function () {
            if (arguments.length > 1) {
                console.log(_.slice(arguments, 0, arguments.length - 1));
            }
            console.log(this);
        });
        handlebars.registerHelper('popoutUrl', function () {
            return helpers.popoutUrl();
        });

        handlebars.registerPartial('addressLine', templates.addressLine);
        handlebars.registerPartial('closeButton', templates.closeButton);
        handlebars.registerPartial('contactEdit', templates.contactEdit);
        handlebars.registerPartial('checkbox', templates.checkbox);
        handlebars.registerPartial('detailsSectionHeader', templates.detailsSectionHeader);
        handlebars.registerPartial('iconButton', templates.iconButton);

        if (callback) {
            callback(null);
        }
    },
    registerHelper: function (name, helper) {
        handlebars.registerHelper(name, helper);
    },
    helpers: helpers,
    templates: templates
};
